module.exports = require("dgram");


//////////////////
// WEBPACK FOOTER
// external "dgram"
// module id = 268
// module chunks = 0 1